import useSWR, { mutate } from 'swr';
import { useMemo } from 'react';

// ==============================|| TYPES ||============================== //

interface MenuMaster {
  isDashboardDrawerOpened: boolean;
}

interface UseMenuMasterReturn {
  menuMaster: MenuMaster;
  menuMasterLoading: boolean;
}

// ==============================|| CONSTANTS ||============================== //

const initialState: MenuMaster = {
  isDashboardDrawerOpened: false
};

const endpoints = {
  key: 'api/menu',
  master: 'master',
  dashboard: '/dashboard' // example server URL
};

// ==============================|| HOOK: useGetMenuMaster ||============================== //

export function useGetMenuMaster(): UseMenuMasterReturn {
  const { data, isLoading } = useSWR<MenuMaster>(endpoints.key + endpoints.master, () => initialState, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });

  const memoizedValue = useMemo(
    () => ({
      menuMaster: data ?? initialState,
      menuMasterLoading: isLoading
    }),
    [data, isLoading]
  );

  return memoizedValue;
}

// ==============================|| HANDLER: Drawer Toggle ||============================== //

export function handlerDrawerOpen(isDashboardDrawerOpened: boolean): void {
  // mutate<MenuMaster>(
  //   endpoints.key + endpoints.master,
  //   (currentMenuMaster) => ({
  //     ...(currentMenuMaster ?? initialState),
  //     isDashboardDrawerOpened
  //   }),
  //   false
  // );

  false
}
